module.exports = __webpack_public_path__ + "img/bg-banner.b29931a2.png";